import { Select, SelectProps, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Image, StyleSheet, View } from 'react-native'
import { ProductType, useProductTypes } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  option: {
    marginTop: Spacing.XS,
    flexDirection: 'row',
    alignItems: 'center',
  },
  image: {
    width: 60,
    height: 60,
    marginRight: Spacing.S,
  },
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  onChange?: (value: number) => void
}

const ProductTypeSelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props

  const productTypes = useProductTypes()

  const renderOption = (type: ProductType) => {
    const { imageUrl, name, articleNumber } = type
    return (
      <View style={styles.option}>
        <Image source={{ uri: imageUrl }} style={styles.image} resizeMode="contain" />
        <View>
          <Text level={5}>{name}</Text>
          <Text level={7}>{articleNumber}</Text>
        </View>
      </View>
    )
  }

  const items = productTypes.data?.map((type) => ({
    value: type.id,
    title: type.name,
    render: () => renderOption(type),
  }))

  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={items}
      testID="ProductTypeSelect.Container"
      value={value}
      {...otherProps}
    />
  )
}

export default ProductTypeSelect
